import { Component, EventEmitter, Input, Output, signal } from '@angular/core'
import { CamaraCapturaComponent } from './camara-captura'
import { FilaPresetComponent } from './fila-preset'
import { FilaFotoComponent } from './fila-foto'
import type { FotoProducto } from '../../application/sesion-captura'

/**
 * Galeria con angulos sugeridos y fotos libres etiquetadas por el usuario.
 * "Frente" se elimino del preset: en la practica la foto "General" ya se toma
 * de frente, tener ambas era redundante y solo sumaba peso en Supabase Storage.
 */
const ETIQUETAS_PRESET = ['General', 'Lado', 'Abajo']

/**
 * Tope de fotos libres adicionales (fuera de los presets). Junto a los 3
 * presets da un maximo de 5 fotos capturadas por producto — de esas, la
 * sincronizacion solo sube 3 (ver sincronizador.ts), pero el limite de
 * captura evita que alguien acumule fotos de mas sin ningun control.
 */
const MAX_FOTOS_LIBRES = 2

@Component({
  selector: 'app-galeria-fotos',
  standalone: true,
  imports: [CamaraCapturaComponent, FilaPresetComponent, FilaFotoComponent],
  templateUrl: './galeria-fotos.html',
})
export class GaleriaFotosComponent {
  @Input({ required: true }) etiquetaSeccion!: string
  @Input({ required: true }) fotos: FotoProducto[] = []
  @Output() agregar = new EventEmitter<{ blob: Blob; etiqueta?: string }>()
  @Output() renombrar = new EventEmitter<{ id: string; etiqueta: string }>()
  @Output() eliminar = new EventEmitter<string>()

  readonly etiquetasPreset = ETIQUETAS_PRESET
  readonly agregandoLibre = signal(false)

  get fotosLibres(): FotoProducto[] {
    return this.fotos.filter((f) => !ETIQUETAS_PRESET.includes(f.etiqueta))
  }

  get seAlcanzoMaximoLibres(): boolean {
    return this.fotosLibres.length >= MAX_FOTOS_LIBRES
  }

  fotoDePreset(etiqueta: string): FotoProducto | undefined {
    return this.fotos.find((f) => f.etiqueta === etiqueta)
  }

  alCapturarPreset(etiqueta: string, blob: Blob): void {
    const existente = this.fotoDePreset(etiqueta)
    if (existente) this.eliminar.emit(existente.id)
    this.agregar.emit({ blob, etiqueta })
  }

  alAgregarLibre(blob: Blob): void {
    this.agregar.emit({ blob })
    this.agregandoLibre.set(false)
  }
}
